/**
 * LoadingScreen - Pantalla de carga simplificada
 * Usado durante la autenticación y carga inicial
 */
const LoadingScreen = ({ message = 'Cargando...' }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-slate-900">
      <div className="text-center space-y-4 animate-fade-in">
        {/* Logo Real */}
        <div className="inline-block mb-2">
          <img 
            src="/logo.png" 
            alt="Illustra" 
            className="w-20 h-20 rounded-2xl"
          />
        </div>

        {/* Spinner */}
        <div className="animate-spin rounded-full h-10 w-10 border-b-3 border-indigo-600 mx-auto"></div>

        {/* Mensaje */}
        <p className="text-sm text-gray-600 dark:text-gray-400">
          {message}
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;
